import PromisedResource from './PromisedResource'

export default class ClientsResource extends PromisedResource {
  constructor({ remote }) {
    super(remote.query(q => q.findRecords('client')))
  }
}
